import { render, staticRenderFns } from "./productsFormEdit.vue?vue&type=template&id=511373ee&"
import script from "./productsFormEdit.vue?vue&type=script&lang=js&"
export * from "./productsFormEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports